import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface BaristaStatsProps {
  todayCount: number;
  avgPrepTime: number;
  activeOrders: number;
  readyOrders: number;
}

export default function BaristaStats({ todayCount, avgPrepTime, activeOrders, readyOrders }: BaristaStatsProps) {
  return (
    <div className="px-3 py-3 overflow-x-auto">
      <div className="flex gap-3 min-w-max">
        {/* Today's orders */}
        <div className="bg-white/5 border border-white/10 rounded-2xl px-4 py-3 flex items-center gap-3 min-w-[130px]">
          <div className="w-9 h-9 rounded-xl bg-primary/20 flex items-center justify-center">
            <Icon name="ShoppingBagIcon" size={18} className="text-primary" />
          </div>
          <div>
            <p className="text-white font-black text-xl font-tabular">{todayCount}</p>
            <p className="text-white/50 text-xs">Bugünkü Sipariş</p>
          </div>
        </div>

        {/* Avg prep time */}
        <div className="bg-white/5 border border-white/10 rounded-2xl px-4 py-3 flex items-center gap-3 min-w-[140px]">
          <div className="w-9 h-9 rounded-xl bg-blue-500/20 flex items-center justify-center">
            <Icon name="ClockIcon" size={18} className="text-blue-400" />
          </div>
          <div>
            <p className="text-white font-black text-xl font-tabular">{avgPrepTime}<span className="text-white/50 text-sm font-normal"> dk</span></p>
            <p className="text-white/50 text-xs">Ort. Hazırlama</p>
          </div>
        </div>

        {/* Active orders */}
        <div className="bg-white/5 border border-white/10 rounded-2xl px-4 py-3 flex items-center gap-3 min-w-[120px]">
          <div className="w-9 h-9 rounded-xl bg-amber-500/20 flex items-center justify-center">
            <Icon name="FireIcon" size={18} className="text-amber-400" />
          </div>
          <div>
            <p className="text-white font-black text-xl font-tabular">{activeOrders}</p>
            <p className="text-white/50 text-xs">Aktif Sipariş</p>
          </div>
        </div>

        {/* Ready orders */}
        <div className="bg-white/5 border border-white/10 rounded-2xl px-4 py-3 flex items-center gap-3 min-w-[120px]">
          <div className="w-9 h-9 rounded-xl bg-green-500/20 flex items-center justify-center">
            <Icon name="CheckCircleIcon" size={18} className="text-green-400" />
          </div>
          <div>
            <p className="text-white font-black text-xl font-tabular">{readyOrders}</p>
            <p className="text-white/50 text-xs">Hazır</p>
          </div>
        </div>
      </div>
    </div>
  );
}